import { useState } from 'react';
import OwnerLoginLayout from 'src/layouts/OwnerLogin/OwnerLoginLayout';
import AuthLoginForm from './AuthLoginForm';
import AuthWithSocial from './AuthWithSocial';

export default function Login(): JSX.Element {
  const [isPhoneAuth, setIsPhoneAuth] = useState(false);

  return (
    <OwnerLoginLayout showRegistration={!isPhoneAuth}>
      <AuthWithSocial onPhoneAuthChange={setIsPhoneAuth} />
      {!isPhoneAuth && <AuthLoginForm />}
    </OwnerLoginLayout>
  );
}
